function AutoInvoiceCtrl(toaster, $stateParams, CommonService, OrganizationSettingsService) {
  'ngInject';

  const vm = this;
  vm.loading = false;
  vm.dataLoading = false;
  vm.organization = {};
  vm.retrieveError = false;
  vm.settings = ['auto_invoice', 'cogs', 'bulk_cost', 'amazon_payout', 'shopify_payout', 'benchmarking'];
  vm.settingStatus = false;
  vm.defaultSetting = {
    amazon_payout: true,
    auto_invoice: true,
    bulk_cost: true,
    cogs: true,
    shopify_payout: true,
    benchmarking: true
  };
  vm.rollBack = false;

  vm.init = function () {
    vm.dataLoading = true;
    OrganizationSettingsService.getOrganizationSettings($stateParams.orgId, function (response) {
      if (response.status == 200) {
        vm.dataLoading = false;
        vm.retrieveError = false;
        vm.organizationSettings = response.data.organization_setting;
        if (!vm.organizationSettings) {
          vm.organizationSettings = vm.defaultSetting;
        }
      } else {
        vm.dataLoading = false;
        vm.retrieveError = true;
      }
    });
  };

  vm.toggleOrganizationSettings = function (setting) {
    if (vm.rollBack) {
      vm.rollBack = false;
      return;
    }
    vm.setSettingsData(setting);
    swal({
      title: 'Are you sure?',
      text: `You are switching ${vm.settingTitle} ${vm.organizationSettings[setting] ? 'on' : 'off'}.`,
      icon: 'warning',
      dangerMode: true,
      buttons: [true, true],
    })
      .then(willDelete => {
        if (willDelete) {
          OrganizationSettingsService.toggleOrganizationSettings($stateParams.orgId, vm.organizationSettings, function (response) {
            vm.loading = false;
            if (response.status == 200) {
              toaster.pop('info', vm.toasterText);
            } else {
              vm.rollBack = true;
              $(`#auto_${setting}`).trigger('click');
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        } else {
          vm.rollBack = true;
          $(`#auto_${setting}`).trigger('click');
          vm.loading = false;
        }
      });
  };

  vm.setSettingsData = function (setting) {
    switch(setting){
      case 'auto_invoice':
        vm.settingTitle = 'Auto Invoice sync';
        vm.toasterText = `Auto invoicing turned ${vm.organizationSettings.auto_invoice ? 'on' : 'off' } successfully.`;
        break;
      case 'cogs':
        vm.settingTitle = 'Cost of Goods Sold sync';
        vm.toasterText = `COGS settings turned ${vm.organizationSettings.cogs ? 'on' : 'off' } successfully.`;
        break;
      case 'bulk_cost':
        vm.settingTitle = 'Bulk Cost sync';
        vm.toasterText = `Bulk cost settings turned ${vm.organizationSettings.bulk_cost ? 'on' : 'off' } successfully.`;
        break;
      case 'amazon_payout':
        vm.settingTitle = 'Amazon Payout sync';
        vm.toasterText = `Amazon payout settings turned ${vm.organizationSettings.amazon_payout ? 'on' : 'off' } successfully.`;
        break;
      case 'shopify_payout':
        vm.settingTitle = 'Shopify Payout sync';
        vm.toasterText = `Shopify payout settings turned ${vm.organizationSettings.shopify_payout ? 'on' : 'off' } successfully.`;
        break;
      case 'benchmarking':
      vm.settingTitle = 'Benchmarking for Reports';
      vm.toasterText = `Benchmarking settings turned ${vm.organizationSettings.benchmarking ? 'on' : 'off' } successfully.`;
      break;
      default:
    }
  };

  vm.tooltipStatus = function (status) {
    if(status){
      return 'Disable';
    }else{
      return 'Enable';
    }
  };
}

export default {
    name: 'AutoInvoiceCtrl',
    fn: AutoInvoiceCtrl
};
